import { api } from "@/lib/axios";
import type {
  AccountPermissionMapping,
  ApiResponse,
  GrantAccountPermissionRequest,
  Permission,
  RevokeAccountPermissionRequest,
  ServiceCategoryType,
  TogglePermissionRequest,
  UpsertPermissionRequest,
} from "../types/permission.types";

export const listPermissions = async (): Promise<Permission[]> => {
  const { data } = await api.get<ApiResponse<Permission[]>>(
    "/api/Permission/List",
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const listPermissionsByCategory = async (
  category: ServiceCategoryType,
): Promise<Permission[]> => {
  const { data } = await api.get<ApiResponse<Permission[]>>(
    `/api/Permission/List/${category}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const upsertPermission = async (
  req: UpsertPermissionRequest,
): Promise<Permission> => {
  const { data } = await api.post<ApiResponse<Permission>>(
    "/api/Permission/Upsert",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const togglePermission = async (
  req: TogglePermissionRequest,
): Promise<Permission> => {
  const { data } = await api.post<ApiResponse<Permission>>(
    "/api/Permission/Toggle",
    req,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

// ===== 계정-개인 권한 =====

export const getAccountPermissions = async (
  accountGuid: string,
): Promise<AccountPermissionMapping[]> => {
  const { data } = await api.get<ApiResponse<AccountPermissionMapping[]>>(
    `/api/AccountPermission/account/${accountGuid}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

/** 최종 권한 코드 = 역할 권한 ∪ 개인 권한 */
export const getAccountEffectivePermissions = async (
  accountGuid: string,
): Promise<string[]> => {
  const { data } = await api.get<ApiResponse<string[]>>(
    `/api/AccountPermission/account/${accountGuid}/effective`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const grantAccountPermission = async (
  params: GrantAccountPermissionRequest,
): Promise<AccountPermissionMapping> => {
  const { data } = await api.post<ApiResponse<AccountPermissionMapping>>(
    "/api/AccountPermission/grant",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const revokeAccountPermission = async (
  params: RevokeAccountPermissionRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/AccountPermission/revoke",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
};
